<template>
  <div
    :id="data.section_anchor"
    class="anchor-module" />
</template>

<script setup>
/* #META
   {
    "NAME": "AnchorComponent",
    "CLASSNAME": "anchor",
    "URL": "http://eikon.local/"
   }
  #ENDMETA */
defineProps(['data'])
</script>
<style lang="scss">
.anchor-module {
  height: 0;
  width: 0;
}
</style>
